// CUSTOM JS FOR ATELIER - Starts
$(document).ready(function() {
  // Skip execution if not in the product page
  try {
    if (typeof productData === 'undefined') {
      return;
    }
  } catch {
    return;
  }
  const product = productData.title;

  const STYLE_CLASSES = {
    leatherColors: (function() {
      const colors = [];
      productData.variants.forEach(variant => {
        const lower = variant.toLowerCase();
        // Always include the variant as is.
        colors.push(lower);
        // If it ends with _gold, also add the base version.
        if (lower.endsWith('_gold')) {
          colors.push(lower.slice(0, -5)); // Remove 5 characters: "_gold"
        } else if (lower.endsWith('_silver')) {
          colors.push(lower.slice(0, -7)); // Remove 7 characters: "_silver"
        }
      });
      // Remove duplicates (if any) by converting to a Set then back to an array.
      return [...new Set(colors)];
    })(),
    foilColors: productData.foils,
    textColors: productData.inks.map(ink => ink.toLowerCase() + '-t'),
    shadowColors: productData.inks.map(ink => ink.toLowerCase() + '-s'),
    fonts: productData.fonts,
    positions: productData.positions
  };

  const FONT_TYPES = {
    PRINT: 'print',
    ENGRAVED: 'engraved',
    STAMP: 'stamp'
  };

  const FONT_CONFIG = {
    'shadow': {
      type: FONT_TYPES.PRINT,
      hasExtraCharge: true,
      hasShadowColors: true,
      defaultColor: 'Crimson',
      defaultShadow: 'Tangerine'
    },
    'classic': {
      type: FONT_TYPES.PRINT,
      hasExtraCharge: true,
      hasShadowColors: false,
      defaultColor: 'Crimson'
    },
    'sketch': {
      type: FONT_TYPES.PRINT,
      hasExtraCharge: true,
      hasShadowColors: false,
      defaultColor: 'Crimson'
    },
    'iridiscente': {
      type: FONT_TYPES.PRINT,
      hasExtraCharge: false,
      hasShadowColors: false,
      defaultColor: 'Midnight'
    },
    'sansserif': {
      type: FONT_TYPES.ENGRAVED
    },
    'serif': {
      type: FONT_TYPES.ENGRAVED
    },
    'smile': {
      type: FONT_TYPES.STAMP,
      hasExtraCharge: true,
      priceLabel: '$5.00'
    }
  };

  const POSITION_CONFIG = {
    'horizontal/vertical': {
      options: ['horizontal', 'vertical'],
      default: 'horizontal',
      defaultText: ' horizontal'
    },
    'top/bottom': {
      options: ['arriba', 'abajo'],
      default: 'arriba',
      defaultText: ' arriba'
    },
    'outside/inside': {
      options: ['afuera', 'adentro'],
      default: 'afuera',
      defaultText: ' afuera'
    }
  };

  const PRICES = {
    singleShadow: '$14.00',
    doubleShadow: '$22.00',
    tripleShadow: '$33.00',
    dome: '$60.00'
  };

  const WAVES_DOTS_INK_MAP = {
    waves: {
      'blush':        { text: '#FEE7E2', shadow: '#F79750' },
      'bone':         { text: '#2A2767', shadow: '#81A5D7' },
      'pumpkin':      { text: '#913221', shadow: '#FBE9E1' },
      'royal_blue':   { text: '#81A5D7', shadow: '#F8F4ED' },
      'lilac_plum':   { text: '#EDBEC5', shadow: '#732645' },
      'lilac_green':  { text: '#FCFCFC', shadow: '#005F40' },
      'baby_blue':    { text: '#F5BE1C', shadow: '#FFFFFF' },
      'butter_yellow': { text: '#F8CBD7', shadow: '#AF205E' },
      'cocoa':        { text: '#FEF9F3', shadow: '#A8CBEA' }
    },
    dots: {
      'blush':    { text: '#FEE7E2', shadow: '#F79750' },
      'bone':     { text: '#73767A', shadow: '#070808' },
      'lilac':    { text: '#EDBEC5', shadow: '#732645' },
      'pumpkin':  { text: '#FEE7E2', shadow: '#28469D' },
      'baby_blue': { text: '#F5BE1C', shadow: '#FFFFFF' },
      'butter_yellow': { text: '#F8CBD7', shadow: '#AF205E' },
      'cocoa':    { text: '#FEF9F3', shadow: '#A8CBEA' }
    }
  };

  const EXTRA_CHARGE = PRICES[productData.extras]

  const EXTRA_CHARGES_CONFIG = {
    shadow: 'shadowcb',
    classic: 'classiccb',
    sketch: 'sketchcb',
    dome: 'domecb',
    smile: 'smilecb'
  };

  // Charm upcharges (Custom Product Options app). Deliberately kept OUT of
  // EXTRA_CHARGES_CONFIG: extraChargeManager.add() clears every charge in that map
  // before applying a new one, and a charm add-on has to survive a paid font being
  // picked (and vice versa). One charm is included in the price.
  const CHARM_CHARGES = {
    2: {checkbox: 'charm2cb', price: '$6.00'},   // app product: Extra Charm
    3: {checkbox: 'charm3cb', price: '$12.00'}   // app product: 2 x Extra Charm
  };

  const MAX_CHARMS = 3;

  // Charm picker artwork lives in assets/<handle>_charm.jpg. The label is what
  // reaches the cart via properties[Charms].
  const CHARMS = [
    {handle: 'banana',      label: 'Banana'},
    {handle: 'bici',        label: 'Bicicleta'},
    {handle: 'cherry',      label: 'Cerezas'},
    {handle: 'heart_melon', label: 'Corazón de Sandía'},
    // Out of stock 2026-08-17 — uncomment to bring the Maleta charm back.
    // {handle: 'luggage',     label: 'Maleta'},
    {handle: 'moto',        label: 'Moto'},
    {handle: 'orange',      label: 'Naranja'},
    {handle: 'pipa',        label: 'Pipa'},
    {handle: 'popsicle',    label: 'Paleta'},
    {handle: 'shroom',      label: 'Hongo'},
    {handle: 'watermelon',  label: 'Sandía'}
  ];

  // Product types eligible for the Operación Sonrisa happy-face stamp
  // (mirrors the original 2024 colab scope; Samsung foldable/flip are excluded
  //  since they post-date the original and have different engraving geometry)
  const SMILE_PRODUCT_TYPES = [
    // 'phone-case',
    // 'phone-case samsung',
    // 'magsafe-wallet',
    // 'round-keychain',
    // 'long-cardholder'
  ];

  const EXTRA_COST_PRODUCTS = [
    'Set de Round Keychain + Cardholder',
    'Set de Round Keychain + Long Cardholder',
    'Set de Jewelry Case + Travel Wallet'
  ];

  const PERSONALIZATION_LIMITS = STYLE_CLASSES.fonts.reduce((limits, font) => {
    limits[font] = 0;
    return limits;
  }, {});

  const HELP_TEXT_BASE = "Nota: Esta vista preliminar es solo un aproximado.";

  const HELP_TEMPLATES = {
    sansserif: `Acepta: a-z, A-Z, 0-9, @, #, &, guión, punto, coma y espacios. <br>Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}`,
    serif: `Acepta: a-z, A-Z, 0-9, @, #, &, guión, punto, coma y espacios. <br>Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}`,
    shadow: `Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}<br><br>`,
    classic: `Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}<br><br>`,
    sketch: `Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}<br><br>`,
    iridiscente: `Máximo: {maxLength} caracteres. ${HELP_TEXT_BASE}<br><br>`,
    smile: `Tu pieza llevará la carita feliz de Operación Sonrisa. Se donarán $5.00 a Operación Sonrisa Panamá.<br><br>`
  };

  const KEYS = {
    navigation: [8, 37, 39, 46], // backspace, left, right, delete
    sansserif: [8, 32, 35, 38, 39, 44, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 222, 225, 233, 237, 241, 243, 250, 252, 8216, 8217],
    serif: [8, 32, 35, 38, 39, 44, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 222, 225, 233, 237, 241, 243, 250, 252, 8216, 8217]
  };

  const CHARS = {
    sansserif: "abcdefghijklmnñopqrstuvwxyzáéíóúüABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.,&-'@# ",
    serif: "abcdefghijklmnñopqrstuvwxyzáéíóúüABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.,&-'@# "
  };

  const PRODUCT_TEMPLATES = {
    phoneCase: {
      maxLengthSansserif: 5,
      maxLengthSerif: 5,
      maxLengthShadow: 5,
      maxLengthClassic: 5,
      maxLengthSketch: 5,
      position: 'horizontal/vertical',
      type: 'phone-case'
    },
    sample: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 0,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      type: 'sample'
    },
    nonPersonalized: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 0,
      maxLengthClassic: 0,
      maxLengthSketch: 0
    },
    iridiscenteCase: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 0,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      maxLengthIridiscente: 3,
      type: 'phone-case'
    },
    holidayStripes: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 3,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      type: 'phone-case'
    },
    holidayBows: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 10,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      type: 'phone-case'
    },
    waves: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 2,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      type: 'phone-case'
    },
    dots: {
      maxLengthSansserif: 0,
      maxLengthSerif: 0,
      maxLengthShadow: 2,
      maxLengthClassic: 0,
      maxLengthSketch: 0,
      type: 'phone-case'
    }
  };

  const PRODUCT_GROUPS = {
    samsung: [
      'The Signature Case Samsung S23',
      'The Signature Case Samsung S23 FE',
      'The Signature Case Samsung S23 Ultra',
      'The Signature Case Samsung S23+',
      'The Signature Case Samsung S24',
      'The Signature Case Samsung S24 Ultra',
      'The Signature Case Samsung S24+',
      'The Signature Case Samsung S25',
      'The Signature Case Samsung S25 Ultra',
      'The Signature Case Samsung S25+',
      'The Signature Case Samsung Z Fold 7',
      'Samsung S23',
      'Samsung S23 FE',
      'Samsung S23 Ultra',
      'Samsung S23+',
      'Samsung S24',
      'Samsung S24 Ultra',
      'Samsung S24+'
    ],
    samsung_foldable: [
    ],
    samsung_flip: [
      'The Signature Case Samsung Z Flip 7'
    ],
    iphone: [
      'The Premium Case iPhone 18 Pro Max',
      'The Premium Case iPhone 18 Pro',
      'The Premium Case iPhone 17 Pro Max',
      'The Premium Case iPhone 17 Pro',
      'The Premium Case iPhone 16 Pro Max',
      'The Premium Case iPhone 16 Pro',
      'The Premium Case iPhone 16 Plus',
      'The Premium Case iPhone 16',
      'The Premium Case iPhone 15 Pro Max',
      'The Premium Case iPhone 15 Pro',
      'The Premium Case iPhone 15 Plus',
      'The Premium Case iPhone 15',
      'The Signature Case iPhone 18 Pro Max',
      'The Signature Case iPhone 18 Pro',
      'The Signature Case iPhone 17 Pro Max',
      'The Signature Case iPhone 17 Pro',
      'The Signature Case iPhone 17',
      'The Signature Case iPhone 16 Pro Max',
      'The Signature Case iPhone 16 Pro',
      'The Signature Case iPhone 16 Plus',
      'The Signature Case iPhone 16',
      'The Signature Case iPhone 15 Pro Max',
      'The Signature Case iPhone 15 Pro',
      'The Signature Case iPhone 15 Plus',
      'The Signature Case iPhone 15',
      'The Signature Case iPhone 14 Pro Max',
      'The Signature Case iPhone 14 Pro',
      'The Signature Case iPhone 14',
      'The Signature Case iPhone 14 Plus',
      'The Signature Case iPhone 13 Pro Max',
      'The Signature Case iPhone 13',
      'The Signature Case iPhone 13 Pro',
      'The Signature Case iPhone 11',
      'The Signature Case iPhone 11 Pro',
      'The Signature Case iPhone 11 Pro Max',
      'The Signature Case iPhone 7Plus/8Plus',
      'The Signature Case iPhone 7/8/SE 2',
      'The Signature Case iPhone X/XS',
      'The Signature Case iPhone XR',
      'The Signature Case iPhone XS Max',
      'The Signature Case iPhone 12 Mini',
      'The Signature Case iPhone 12/12 Pro',
      'The Signature Case iPhone 12 Pro Max',
      'iPhone 16 Pro Max',
      'iPhone 16 Pro',
      'iPhone 16 Plus',
      'iPhone 16',
      'iPhone 15 Pro Max',
      'iPhone 15 Pro',
      'iPhone 15 Plus',
      'iPhone 15',
      'iPhone 14 Pro Max',
      'iPhone 14 Pro',
      'iPhone 14',
      'iPhone 14 Plus',
      'iPhone 13 Pro Max',
      'iPhone 13',
      'iPhone 13 Pro',
      'iPhone 11',
      'iPhone 11 Pro',
      'iPhone 11 Pro Max',
      'iPhone 7Plus/8Plus',
      'iPhone 7/8/SE 2',
      'iPhone X/XS',
      'iPhone XR',
      'iPhone XS Max',
      'iPhone 12 Mini',
      'iPhone 12/12 Pro',
      'iPhone 12 Pro Max'
    ],
    holidayStripes: [
      'iPhone 17 Pro Max - Stripes',
      'iPhone 17 Pro - Stripes',
      'iPhone 16 Pro Max - Stripes',
      'iPhone 16 Pro - Stripes',
      'iPhone 16 Plus - Stripes',
      'iPhone 16 - Stripes',
      'iPhone 15 Pro Max - Stripes',
      'iPhone 15 Pro - Stripes',
      'iPhone 15 Plus - Stripes',
      'iPhone 15 - Stripes',
      'iPhone 14 Pro Max - Stripes',
      'iPhone 14 Pro - Stripes',
      'iPhone 14 - Stripes',
      'iPhone 14 Plus - Stripes',
      'iPhone 13 Pro Max - Stripes',
      'iPhone 13 - Stripes',
      'iPhone 13 Pro - Stripes',
      'Valet Tray - Stripes',
      'Samsung S23 - Stripes',
      'Samsung S23 FE - Stripes',
      'Samsung S23 Ultra - Stripes',
      'Samsung S23+ - Stripes',
      'Samsung S24 - Stripes',
      'Samsung S24 Ultra - Stripes',
      'Samsung S24+ - Stripes',
      'Samsung S25 - Stripes',
      'Samsung S25 Ultra - Stripes',
      'Samsung S25+ - Stripes'
    ],
    holidayBows: [
      'iPhone 17 Pro Max - Bows',
      'iPhone 17 Pro - Bows',
      'iPhone 16 Pro Max - Bows',
      'iPhone 16 Pro - Bows',
      'iPhone 16 Plus - Bows',
      'iPhone 16 - Bows',
      'iPhone 15 Pro Max - Bows',
      'iPhone 15 Pro - Bows',
      'iPhone 15 Plus - Bows',
      'iPhone 15 - Bows',
      'iPhone 14 Pro Max - Bows',
      'iPhone 14 Pro - Bows',
      'iPhone 14 - Bows',
      'iPhone 14 Plus - Bows',
      'iPhone 13 Pro Max - Bows',
      'iPhone 13 - Bows',
      'iPhone 13 Pro - Bows',
      'Valet Tray - Bows',
      'Samsung S23 - Bows',
      'Samsung S23 FE - Bows',
      'Samsung S23 Ultra - Bows',
      'Samsung S23+ - Bows',
      'Samsung S24 - Bows',
      'Samsung S24 Ultra - Bows',
      'Samsung S24+ - Bows',
      'Samsung S25 - Bows',
      'Samsung S25 Ultra - Bows',
      'Samsung S25+ - Bows',
    ],
    waves: [
      'iPhone 18 Pro Max - Waves',
      'iPhone 18 Pro - Waves',
      'iPhone 17 Pro Max - Waves',
      'iPhone 17 Pro - Waves',
      'iPhone 17 - Waves',
      'iPhone 16 Pro Max - Waves',
      'iPhone 16 Plus - Waves',
      'iPhone 16 Pro - Waves',
      'iPhone 16 - Waves',
      'iPhone 15 Pro Max - Waves',
      'iPhone 15 Pro - Waves',
      'iPhone 15 Plus - Waves',
      'iPhone 15 - Waves',
      'iPhone 14 Pro Max - Waves',
      'iPhone 14 Pro - Waves',
      'iPhone 14 Plus - Waves',
      'iPhone 14 - Waves',
      'iPhone 13 Pro Max - Waves',
      'iPhone 13 Pro - Waves',
      'iPhone 13 - Waves',
      'Samsung S23 - Waves',
      'Samsung S23 FE - Waves',
      'Samsung S23 Ultra - Waves',
      'Samsung S23+ - Waves',
      'Samsung S24 - Waves',
      'Samsung S24 Ultra - Waves',
      'Samsung S24+ - Waves',
      'Samsung S25 - Waves',
      'Samsung S25 Ultra - Waves',
      'Samsung S25+ - Waves'
    ],
    dots: [
      'iPhone 18 Pro Max - Dots',
      'iPhone 18 Pro - Dots',
      'iPhone 17 Pro Max - Dots',
      'iPhone 17 Pro - Dots',
      'iPhone 17 - Dots',
      'iPhone 16 Pro Max - Dots',
      'iPhone 16 Pro - Dots',
      'iPhone 16 Plus - Dots',
      'iPhone 16 - Dots',
      'iPhone 15 Pro Max - Dots',
      'iPhone 15 Pro - Dots',
      'iPhone 15 Plus - Dots',
      'iPhone 15 - Dots',
      'iPhone 14 Pro Max - Dots',
      'iPhone 14 Pro - Dots',
      'iPhone 14 Plus - Dots',
      'iPhone 14 - Dots',
      'iPhone 13 Pro Max - Dots',
      'iPhone 13 Pro - Dots',
      'iPhone 13 - Dots',
      'Samsung S23 - Dots',
      'Samsung S23 FE - Dots',
      'Samsung S23 Ultra - Dots',
      'Samsung S23+ - Dots',
      'Samsung S24 - Dots',
      'Samsung S24 Ultra - Dots',
      'Samsung S24+ - Dots',
      'Samsung S25 - Dots',
      'Samsung S25 Ultra - Dots',
      'Samsung S25+ - Dots'
    ],
    tech: [
      'Phone Strap',
      'Hand Strap',
      'UV Sanitizer',
      'Protector de Cámara',
      'Protector de Pantalla',
      'Set de Protector de Cámara + Protector de Pantalla',
      'Cargador inalámbrico con soporte de teléfono para carro - ESR HaloLock',
      'USB-C 20W Power Adapter - Apple',
      'Hexagonal Pen'
    ],
    giftCards: ['e-Gift Card', 'e-Heart for VZLA'],
    magsafeBuddy: ['MagSafe Buddy']
  };

  PRODUCT_GROUPS.samples = {
    phoneCase: [
      'iPhone X/XS - VS',
      'iPhone X/XS - AS',
      'iPhone 11 Pro Max - KW',
      'iPhone 11 Pro Max - ROD',
      'iPhone 12/12 Pro - AF',
      'iPhone 12/12 Pro - GABS',
      'iPhone X/XS - MILY',
      'iPhone 11 Pro Max - AO',
      'iPhone 12 Pro Max - GC',
      'iPhone 11 Pro Max - HAPPY'
    ],
    airpod: [
      'Airpod Case Pro - Emoji Luna',
      'Airpod Case Pro - SA',
      'Airpod Case Pro - SB',
      'Airpod Case Pro - EI'
    ],
    cardholder: [
      'Cardholder - Agustina',
      'Cardholder - Izabela',
      'Cardholder - JR',
      'Cardholder - ODC',
      'Cardholder - PK',
      'Cardholder - TA',
      'Cardholder - CR',
      'Cardholder - L',
      'Cardholder - LC',
      'Cardholder - MM',
      'Cardholder - SBR',
      'Cardholder - M',
    ],
    jewelryCase: [
      'Jewelry Case - MAG',
      'Jewelry Case - Alina',
      'Jewelry Case - CH',
      'Jewelry Case - E',
      'Jewelry Case - EBA',
      'Jewelry Case - FLORA',
      'Jewelry Case - ITC',
      'Jewelry Case - MLT',
      'Jewelry Case - R.N.S',
      'Jewelry Case - S'
    ],
    pinkHope: [
      'Charm Pink Hope - AM',
      'Charm Pink Hope - GdP',
      'Charm Pink Hope - MLY',
      'Charm Pink Hope - PC',
      'Charm Pink Hope - PFS',
      'Charm Pink Hope - MA'
    ],
    hangtag: [
      'Hangtag - KAT',
      'Hangtag - M',
      'Hangtag - MT'
    ],
    longCardholder: [
      'Long Cardholder - AR',
      'Long Cardholder - CT',
      'Long Cardholder - AS',
      'Long Cardholder - GC',
      'Long Cardholder - S.K'
    ],
    moneyClip: [
      'Money Clip Wallet - UGA',
      'Money Clip Wallet - JHM',
      "Men's Wallet - R"
    ],
    phoneGrip: [
      'Phone Grip - M',
      'Phone Grip - Emoji Fuego'
    ],
    roundKeychain: [
      'Round Keychain - MO',
      'Round Keychain - PASK',
      'Round Keychain - VR'
    ],
    valetKeychain: [
      'Fight Hunger Valet Keychain - AB',
      'Fight Hunger Valet Keychain - CCA',
      'Fight Hunger Valet Keychain - MF',
      'Fight Hunger Valet Keychain - NUM',
      'Fight Hunger Valet Keychain - RAA'
    ],
    fauna: [
      "Set de papelería - Perico Fauna",
      "Set de papelería - Jaguar Fauna",
      "Set de papelería - Mariposa Fauna"
    ]
  };

  PRODUCT_GROUPS.allSamples = Object.values(PRODUCT_GROUPS.samples).flat();

  const CUSTOM_PRODUCTS = {
    'LOGO': {
      'maxLengthSansserif': 0,
      'maxLengthSerif': 0,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'logo'
    },
    // VALENTINES: Remove after Valentine's Day
    'LOVE & JOY': {
      'maxLengthSansserif': 0,
      'maxLengthSerif': 0,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'love-and-joy'
    },
    'Besties Duo': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'besties-duo'
    },
    'Notebook': {
      'maxLengthSansserif': 8,
      'maxLengthSerif': 8,
      'maxLengthShadow': 6,
      'maxLengthClassic': 6,
      'maxLengthSketch': 6,
      'type': 'notebook'
    },
    '15-inch Slim Laptop/iPad Sleeve': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 6,
      'maxLengthClassic': 6,
      'maxLengthSketch': 6,
      'type': 'laptop-sleeve'
    },
    'Airpod Case 1 & 2 Gen': {
      'maxLengthSansserif': 2,
      'maxLengthSerif': 2,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'airpod-case'
    },
    'Airpod Case (3, Pro 2, Pro)': {
      'maxLengthSansserif': 2,
      'maxLengthSerif': 2,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'airpod-case-pro'
    },
    'Cardholder': {
      'maxLengthSansserif': 7,
      'maxLengthSerif': 7,
      'maxLengthShadow': 6,
      'maxLengthClassic': 6,
      'maxLengthSketch': 6,
      'type': 'cardholder'
    },
    'The Premium MagSafe Wallet': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'magsafe-wallet'
    },
    'The Signature MagSafe Wallet': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'magsafe-wallet'
    },
    'Long Cardholder': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'long-cardholder',
      'position': 'horizontal/vertical'
    },
    'Set de Passport Holder + Luggage Tag': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow':3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'set'
    },
    'Set de 2 Luggage Tags': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'set'
    },
    'Set de 3 Luggage Tags': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'set'
    },
    'Set de Valet Tray + Laptop Sleeve': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 4,
      'maxLengthClassic': 4,
      'maxLengthSketch': 4,
      'type': 'set'
    },
    'Set de Men\'s Toiletry + Wallet': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Large Cosmetic Bag': {
      'maxLengthSansserif': 7,
      'maxLengthSerif': 7,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'large-cosmetic-bag'
    },
    'Small Cosmetic Bag': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'small-cosmetic-bag'
    },
    'Set de Small + Large Cosmetic Bag': {
      'maxLengthSansserif': 7,
      'maxLengthSerif': 7,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Clear Cosmetic Bag Large': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'clear-cosmetic-bag-large'
    },
    'Clear Cosmetic Bag Small': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'clear-cosmetic-bag-small'
    },
    'Set de Toiletry + Clear Cosmetic Bags': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Set de Clear Cosmetic Bags': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Set de Jewelry Case + Travel Wallet': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 5,
      'maxLengthClassic': 5,
      'maxLengthSketch': 5,
      'type': 'set'
    },
    'Hangtag': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 6,
      'maxLengthClassic': 6,
      'maxLengthSketch': 6,
      'type': 'hangtag',
      'position': 'horizontal/vertical'
    },
    'Jewelry Case': {
      'maxLengthSansserif': 6,
      'maxLengthSerif': 6,
      'maxLengthShadow': 6,
      'maxLengthClassic': 6,
      'maxLengthSketch': 6,
      'type': 'jewelry-case'
    },
    'Luggage Tag': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'luggage-tag'
    },
    'Phone Grip': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'phone-grip'
    },
    'Charm Pink Hope': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'pink-hope'
    },
    'Heart': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'heart'
    },
    'Round Keychain': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 2,
      'maxLengthClassic': 2,
      'maxLengthSketch': 2,
      'type': 'round-keychain'
    },
    'Charming Keychain': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 2,
      'maxLengthClassic': 2,
      'maxLengthSketch': 2,
      'type': 'round-keychain'
    },
    'Set de Round Keychain + Long Cardholder': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 2,
      'maxLengthClassic': 2,
      'maxLengthSketch': 2,
      'type': 'set'
    },
    'Money Clip Wallet': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'money-clip-wallet',
      'position': 'outside/inside'
    },
    "Men's Wallet": {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'money-clip-wallet',
      'position': 'outside/inside'
    },
    "Watch Case": {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'watch-case',
    },
    'Set de Round Keychain + Cardholder': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 2,
      'maxLengthClassic': 2,
      'maxLengthSketch': 2,
      'type': 'set'
    },
    'Set de Travel Wallet + Luggage Tag': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 4,
      'maxLengthClassic': 4,
      'maxLengthSketch': 4,
      'type': 'set'
    },
    'Set de Toiletry Bag + Small & Large Cosmetic Bag': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Travel Wallet': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'travel-wallet'
    },
    'Valet Tray': {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 4,
      'maxLengthClassic': 4,
      'maxLengthSketch': 4,
      'type': 'valet-tray'
    },
    'Toiletry Bag': {
      'maxLengthSansserif': 5,
      'maxLengthSerif': 5,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'toiletry-bag'
    },
    "Men's Toiletry": {
      'maxLengthSansserif': 4,
      'maxLengthSerif': 4,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'toiletry-bag'
    },
    'Set de Protector de Cámara + Protector de Pantalla': {
      'maxLengthSansserif': 0,
      'maxLengthSerif': 0,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Set de papelería - Mariposa Iridiscente': {
      'maxLengthSansserif': 0,
      'maxLengthSerif': 0,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'set'
    },
    'Phone Wallet': {
      'maxLengthSansserif': 3,
      'maxLengthSerif': 3,
      'maxLengthShadow': 3,
      'maxLengthClassic': 3,
      'maxLengthSketch': 3,
      'type': 'magsafe-wallet'
    },
    'Dot Charm': {
      'maxLengthSansserif': 1,
      'maxLengthSerif': 0,
      'maxLengthShadow': 0,
      'maxLengthClassic': 0,
      'maxLengthSketch': 0,
      'type': 'dot-charm'
    },
  };

  const HIDDEN_PRODUCTS = [
    '22582600630440', // shadow
    '30053267603677', // pattern3
    '30053261639901', // pattern2
    '30053255708893', // pattern1
    '30053251809501', // petPortrait1
    '30110311252189', // petPortrait2
    '30110321934557'  // petPortrait3
  ];

  const CONFIG = {
    styles: {
      classes: STYLE_CLASSES,
      fonts: FONT_CONFIG,
      fontType: FONT_TYPES,
      positions: POSITION_CONFIG
    },
    pricing: {
      prices: PRICES,
      extraCharge: EXTRA_CHARGE,
      extraChargesConfig: EXTRA_CHARGES_CONFIG
    },
    personalization: {
      limits: PERSONALIZATION_LIMITS,
      helpText: {
        base: HELP_TEXT_BASE,
        templates: HELP_TEMPLATES
      },
      allowedChars: {
        keys: KEYS,
        chars: CHARS
      }
    },
    products: {
      templates: PRODUCT_TEMPLATES,
      groups: PRODUCT_GROUPS,
      custom: CUSTOM_PRODUCTS,
      extraCost: EXTRA_COST_PRODUCTS,
      hidden: HIDDEN_PRODUCTS
    },
    emojis: {
      list: [
        {name: 'abeja', unicode: '\ue900', label: 'Bee'},
        {name: 'arcoiris', unicode: '\ue901', label: 'Rainbow'},
        {name: 'avion', unicode: '\ue902', label: 'Plane'},
        {name: 'bicicleta', unicode: '\ue903', label: 'Bicycle'},
        {name: 'brillo', unicode: '\ue904', label: 'Sparkle'},
        {name: 'carita-feliz', unicode: '\ue905', label: 'Happy Face'},
        {name: 'coctel', unicode: '\ue906', label: 'Cocktail'},
        {name: 'corazon', unicode: '\ue907', label: 'Heart'},
        {name: 'fuego', unicode: '\ue908', label: 'Fire'},
        {name: 'luna', unicode: '\ue909', label: 'Moon'},
        {name: 'ola', unicode: '\ue90a', label: 'Wave'},
        {name: 'patita', unicode: '\ue90b', label: 'Paw'},
        {name: 'perro', unicode: '\ue90c', label: 'Dog'},
        {name: 'caballo', unicode: '\ue910', label: 'Horse'},
        {name: 'flor', unicode: '\ue911', label: 'Flower'},
        {name: 'gato', unicode: '\ue912', label: 'Cat'},
        {name: 'pelota-futbol', unicode: '\ue90d', label: 'Soccer Ball'},
        {name: 'tucan', unicode: '\ue915', label: 'Toucan'},
        {name: 'palmera', unicode: '\ue916', label: 'Palm Tree'}
      ]
    },
    charms: {
      list: CHARMS,
      charges: CHARM_CHARGES,
      max: MAX_CHARMS
    }
  };

  // Add emoji characters to CHARS.sansserif and CHARS.serif after CONFIG is defined
  CHARS.sansserif += CONFIG.emojis.list.map(e => e.unicode).join('');
  CHARS.serif += CONFIG.emojis.list.map(e => e.unicode).join('');

  // Group related personalization selectors
  const personalizationBase = '.make-it-personal';
  const personalizationSelectors = {
    monogram: `${personalizationBase}.monogram`,
    font: `${personalizationBase}.font`,
    foilColor: `${personalizationBase}.foil-color`,
    shadowTextFont: `${personalizationBase}.shadow-text-font-color`,
    shadowTextShadow: `${personalizationBase}.shadow-text-shadow-color`
  };

  // Main personalization option groups
  const personalizationOptionsAll$ = $(Object.values(personalizationSelectors).join(', '));
  const personalizationOptionsSome$ = $([
    personalizationSelectors.monogram,
    personalizationSelectors.font,
    personalizationSelectors.foilColor
  ].join(', '));

  // Core elements
  const monogram$ = $('#monogram');
  const helpBlock$ = $('.help-block');
  const engrave$ = $('.engrave');
  let prevMonogram = '';

  // Position related elements
  const monogramPosition$ = $('.make-it-personal.position');
  const monogramPositionOptions$ = $('.make-it-personal.position .position');
  const positions = Object.values(CONFIG.styles.positions).flatMap(position => position.options);
  const positionElements = positions.reduce((elements, position) => {
    elements[position] = $(`.position.${position}`);
    return elements;
  }, {});
  const selectedPosition$ = $('.selected-position');

  // Font related elements
  const fontSelection$ = $('.font-selection');
  const fontElements = CONFIG.styles.classes.fonts.reduce((elements, font) => {
    elements[font] = $(`.font-selection.${font}`);
    return elements;
  }, {});
  const selectedFont$ = $('.selected-font');

  // Foil related elements
  const foilColors$ = $('.foil-color');
  const foilSelection$ = $('.foil-selection');
  const defaultFoil$ = $('.foil-selection.ciego');
  const selectedFoil$ = $('.selected-foil');

  // Shadow text related elements
  const shadowText = {
    fontColors$: $('.shadow-text-font-color'),
    fontColorsSelection$: $('.shadow-text-font-color-selection'),
    shadowColors$: $('.shadow-text-shadow-color'),
    shadowColorsSelection$: $('.shadow-text-shadow-color-selection'),
    defaultFontColor$: $('.shadow-text-font-color-selection.crimson'),
    defaultShadowColor$: $('.shadow-text-shadow-color-selection.tangerine'),
    selectedTextColor$: $('.selected-text-color'),
    selectedShadowColor$: $('.selected-shadow-color')
  };

  // Hidden inputs
  const formElements = {
    font$: $('#font'),
    foil$: $('#foil'),
    shadow$: $('#shadow-color')
  };

  // Swatch elements
  const swatches$ = $('.single-option-selector__radio');
  const defaultSwatch$ = $('#color-1');

  // Navigation elements
  const thumbs$ = $('.product-single__thumb');
  const slickArrows$ = $('.icon-slide-next, .icon-slide-prev');
  const slickDots$ = $('ul.slick-dots li');

  let currentFont = 'sansserif';

  const iridiscenteSetup = () => {
    // Helper function to create Iridiscente variant name
    const createIridescenteName = (baseName) => `${baseName} - Iridiscente`;

    // Helper function to create Iridiscente template based on product type
    const createIridescenteTemplate = (productType) => {
      const baseTemplate = {
        maxLengthSansserif: 0,
        maxLengthSerif: 0,
        maxLengthShadow: 0,
        maxLengthClassic: 0,
        maxLengthSketch: 0,
        maxLengthIridiscente: 3
      };

      switch (productType) {
        case 'jewelry-case':
          return { ...baseTemplate, type: 'jewelry-case' };
        case 'long-cardholder':
          return {
            ...baseTemplate,
            type: 'long-cardholder'
          };
        case 'magsafe-wallet':
          return { ...baseTemplate, type: 'magsafe-wallet' };
        case 'samsung':
          return { ...baseTemplate, type: 'phone-case samsung' };
        case 'samsung_foldable':
          return { ...baseTemplate, type: 'phone-case samsung foldable' };
        case 'samsung_flip':
          return { ...baseTemplate, type: 'phone-case samsung flip' };
        default:
          return { ...baseTemplate, type: 'phone-case' };
      }
    };

    // Add Iridiscente variants to product groups
    const customIridescenteProducts = [
      { name: 'Jewelry Case', type: 'jewelry-case' },
      { name: 'Long Cardholder', type: 'long-cardholder' },
      { name: 'MagSafe Wallet', type: 'magsafe-wallet' }
    ];

    // Create templates object to return
    const iridescenteTemplates = {};

    // Add iPhone Iridiscente variants
    CONFIG.products.groups.iphone.forEach(product => {
      const iridescenteName = createIridescenteName(product);
      iridescenteTemplates[iridescenteName] = createIridescenteTemplate('iphone');
    });

    // Add Samsung Iridiscente variants
    CONFIG.products.groups.samsung.forEach(product => {
      const iridescenteName = createIridescenteName(product);
      iridescenteTemplates[iridescenteName] = createIridescenteTemplate('samsung');
    });

    // Add custom product Iridiscente variants
    customIridescenteProducts.forEach(product => {
      const iridescenteName = createIridescenteName(product.name);
      iridescenteTemplates[iridescenteName] = createIridescenteTemplate(product.type);
    });

    return iridescenteTemplates;
  };

  // Build the complete productProps object
  const buildProductProps = () => {
    let productProps = { ...CONFIG.products.custom };

    // Define fauna collection product suffixes
    const faunaSuffixes = [
      '- Mariposa de cristal',
      '- Mariposa de Cristal',
      '- Panthera Onca',
      '- Periquito Barbinaranja',
      '- Periquito Barbinaranja Pattern'
    ];

    // Helper function to check if a product is from fauna collection
    const isFaunaProduct = (productTitle) => {
      return faunaSuffixes.some(suffix => productTitle.endsWith(suffix));
    };
    console.log('is fauna', isFaunaProduct(product))
    // Helper function to create fauna product template (no personalization)
    const createFaunaTemplate = (baseTemplate) => {
      return {
        ...baseTemplate,
        maxLengthSansserif: 0,
        maxLengthSerif: 0,
        maxLengthShadow: 0,
        maxLengthClassic: 0,
        maxLengthSketch: 0,
        maxLengthIridiscente: 0
      };
    };

    // Add Samsung phone cases
    CONFIG.products.groups.samsung.forEach(product => {
      if (isFaunaProduct(product)) {
        productProps[product] = createFaunaTemplate({
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung'
        });
      } else {
        productProps[product] = {
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung'
        };
      }
    });

    // Add Samsung foldable phone cases
    CONFIG.products.groups.samsung_foldable.forEach(product => {
      if (isFaunaProduct(product)) {
        productProps[product] = createFaunaTemplate({
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung foldable'
        });
      } else {
        productProps[product] = {
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung foldable'
        };
      }
    });

    // Add Samsung flip phone cases
    CONFIG.products.groups.samsung_flip.forEach(product => {
      if (isFaunaProduct(product)) {
        productProps[product] = createFaunaTemplate({
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung flip'
        });
      } else {
        productProps[product] = {
          ...CONFIG.products.templates.phoneCase,
          type: 'phone-case samsung flip'
        };
      }
    });

    // Add iPhone cases
    CONFIG.products.groups.iphone.forEach(product => {
      if (isFaunaProduct(product)) {
        productProps[product] = createFaunaTemplate({
          ...CONFIG.products.templates.phoneCase
        });
      } else {
        productProps[product] = { ...CONFIG.products.templates.phoneCase };
      }
    });

    // Add stripes products
    CONFIG.products.groups.holidayStripes.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.holidayStripes,
        type: 'iphone-case stripes'
      };
    });

    // Add tech products
    CONFIG.products.groups.holidayBows.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.holidayBows,
        type: 'iphone-case bows'
      };
    });

    // Add Waves products
    CONFIG.products.groups.waves.forEach(product => {
      const isSamsung = product.includes('Samsung');
      productProps[product] = {
        ...CONFIG.products.templates.waves,
        type: isSamsung ? 'phone-case samsung waves' : 'phone-case waves'
      };
    });

    // Add Dots products
    CONFIG.products.groups.dots.forEach(product => {
      const isSamsung = product.includes('Samsung');
      productProps[product] = {
        ...CONFIG.products.templates.dots,
        type: isSamsung ? 'phone-case samsung dots' : 'phone-case dots'
      };
    });

    // Add tech products
    CONFIG.products.groups.tech.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.nonPersonalized,
        type: 'tech'
      };
    });

    // Add gift cards
    CONFIG.products.groups.giftCards.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.nonPersonalized,
        type: 'gift-card'
      };
    });

    // Add MagSafe Buddy
    CONFIG.products.groups.magsafeBuddy.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.nonPersonalized,
        type: 'magsafe-buddy'
      };
    });

    // Add samples
    CONFIG.products.groups.allSamples.forEach(product => {
      productProps[product] = {
        ...CONFIG.products.templates.sample,
        type: 'sample'
      };
    });

    // Add Iridiscente products
    const iridescenteProducts = iridiscenteSetup();
    productProps = { ...productProps, ...iridescenteProducts };

    // Handle any fauna products that might not be covered by specific groups
    if (typeof product !== 'undefined' && isFaunaProduct(product) && !productProps[product]) {
      productProps[product] = createFaunaTemplate({
        maxLengthSansserif: 0,
        maxLengthSerif: 0,
        maxLengthShadow: 0,
        maxLengthClassic: 0,
        maxLengthSketch: 0,
        maxLengthIridiscente: 0,
        type: 'fauna'
      });
    }

    return productProps;
  };

  // Create the final productProps object
  const productProps = buildProductProps();

  // Dot Charm: emoji-only, single-character personalization (see CUSTOM_PRODUCTS 'Dot Charm').
  // The monogram field shows the emoji picker on focus and accepts exactly one emoji.
  const isCharm = (typeof product !== 'undefined') && productProps[product]?.type === 'dot-charm';

  // Storage for user entered monograms
  const monogramStorage = CONFIG.styles.classes.fonts.reduce((storage, font) => {
    storage[font] = '';
    return storage;
  }, {});

  let currentLeather = '';

  // Engrave management functions
  const engraveManager = {
    clear() {
      // Flatten the arrays, transform each element, and join with spaces
      const classesArray = Object.values(CONFIG.styles.classes).flat();
      const formattedClasses = classesArray.map(className =>
        className.toLowerCase().replace(/ /g, '_')
      ).join(' ');

      engrave$
        .text('')
        .removeClass(formattedClasses);
    },

    hide() {
      engrave$.hide();
    },

    show() {
      engrave$.show();
      this.setText(currentFont)
    },

    reset() {
      this.clear();
      engrave$.addClass('sansserif ciego');
      this.show();
    },

    setText(font) {
      engrave$.text(monogramManager.get(font));
    },

    isMainPhoto(altText) {
      return altText?.includes('Main');
    },

    toggleVisibility(altText) {
      this.isMainPhoto(altText) ? this.show() : this.hide();
    }
  };

  // Help text management
  const helpTextManager = {
    get(type) {
      return CONFIG.personalization.helpText.templates[type].replace(
        '{maxLength}',
        CONFIG.personalization.limits[type]
      );
    }
  };

  // String utilities
  const stringUtils = {
    toProperCase(str) {
      return str.replace(/\w\S*/g, txt =>
        txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
      );
    }
  };

  // Extra charge management
  //
  // The checkboxes live in the Custom Product Options app widget, which is injected
  // asynchronously a few seconds after the page is interactive. A customer can pick a
  // paid font before they exist, so `desired` records the intended charge and
  // appOptionsSync re-applies it once the app renders (and again right before submit).
  const extraChargeManager = {
    desired: null,

    // Get fresh reference to checkbox
    getCheckbox(value) {
      return $(`input:checkbox[value=${value}]`);
    },

    // Remove all extra charges
    removeAll() {
      this.desired = null;
      Object.values(CONFIG.pricing.extraChargesConfig).forEach(value => {
        const checkbox = this.getCheckbox(value);
        if (checkbox.length > 0 && checkbox.is(':checked')) {
          checkbox.trigger('click');
        }
      });
    },

    // Add specific extra charge
    add(type) {
      this.removeAll();
      this.desired = type;
      const checkbox = this.getCheckbox(CONFIG.pricing.extraChargesConfig[type]);
      if (checkbox.length > 0 && !checkbox.is(':checked')) {
        checkbox.trigger('click');
      }
    },

    // Make the app checkboxes match `desired` (no-op when already in sync).
    sync() {
      Object.entries(CONFIG.pricing.extraChargesConfig).forEach(([type, value]) => {
        const checkbox = this.getCheckbox(value);
        if (!checkbox.length) return;
        const shouldBeChecked = type === this.desired;
        if (shouldBeChecked !== checkbox.is(':checked')) {
          checkbox.trigger('click');
        }
      });
    }
  };

  // Personalization display manager
  const personalizationManager = {
    show() {
      personalizationOptionsSome$.show();
    },

    hide() {
      personalizationOptionsAll$.hide();
    },

    reset() {
      this.resetMonogram();
      this.resetFont();
      this.resetFoil();
      this.resetShadowText();
      extraChargeManager.removeAll();
    },

    resetMonogram() {
      monogram$.val('');
    },

    resetFont() {
      fontSelection$.removeClass('selected');
      fontVisibilityManager.defaultFont$.addClass('selected');
    },

    resetFoil() {
      foilSelection$.removeClass('selected');
      defaultFoil$.addClass('selected');
    },

    resetShadowText() {
      shadowText.fontColors$.removeClass('selected');
      shadowText.shadowColors$.removeClass('selected');
      shadowText.defaultFontColor$.addClass('selected');
      shadowText.defaultShadowColor$.addClass('selected');
    }
  };

  // Monogram management
  const monogramManager = {
    storage: monogramStorage,

    getFontSettings() {
      const settings = {};
      // Initialize the monogram max length for each font type
      Object.keys(CONFIG.personalization.limits).forEach(type => {
        const propName = `maxLength${stringUtils.toProperCase(type)}`;
        if (typeof product !== 'undefined' && productProps[product]) {
          CONFIG.personalization.limits[type] = productProps[product][propName] || 0;
        } else {
          CONFIG.personalization.limits[type] = 0;
        }
      });
      // Operación Sonrisa is gated by product type, not a maxLength property
      if ('smile' in CONFIG.personalization.limits) {
        const productType = (typeof product !== 'undefined' && productProps[product])
          ? productProps[product].type
          : null;
        CONFIG.personalization.limits.smile = SMILE_PRODUCT_TYPES.includes(productType) ? 1 : 0;
      }
      // Pre-order items: only engraved fonts (sans serif / serif) with the
      // standard foils. Zero every other font so it is never shown or offered.
      if (productData.preorder) {
        Object.keys(CONFIG.personalization.limits).forEach(type => {
          if (type !== 'sansserif' && type !== 'serif') {
            CONFIG.personalization.limits[type] = 0;
          }
        });
      }
      // Initialize the monogram settings for each font type
      CONFIG.styles.classes.fonts.forEach(font => {
        settings[font] = {
          type: font,
          maxLength: CONFIG.personalization.limits[font],
          isUpperCase: font === 'iridiscente'
        };
      });
      return settings;
    },

    fontSettings: {},

    save(font) {
      this.storage[font] = monogram$.val();
    },

    get(font) {
      return this.storage[font] || '';
    },

    set(font) {
      // Operación Sonrisa is a happy-face stamp: no monogram text input.
      if (font === 'smile') {
        monogram$.prop('disabled', true)
                 .prop('required', false)
                 .removeClass('required')
                 .removeAttr('maxlength')
                 .val('');
        helpBlock$.html(helpTextManager.get('smile'));
        return;
      }

      // Enable and set as required
      monogram$.prop('disabled', false)
               .prop('required', true)
               .addClass('required');

      // Get font specific settings
      const fontSetting = this.fontSettings ? this.fontSettings[font] : null;
      if (!fontSetting) return;

      // Apply settings
      monogram$
        .attr('maxlength', fontSetting.maxLength)
        .toggleClass('upper', fontSetting.isUpperCase)
        .val(this.get(font));

      // The saved monogram may contain emojis: re-derive the picker state and the
      // hidden emoji-names field from the restored text (fontManager.update ran
      // before the text was restored, so it analyzed the previous font's value).
      if (emojiManager.isSupportedFont()) {
        emojiManager.analyzeText(monogram$.val());
      }

      // Dot Charm is an emoji-only field, so the standard "Acepta: a-z..." help doesn't apply.
      if (isCharm) {
        helpBlock$.html('Selecciona un emoji para el charm.');
      } else {
        helpBlock$.html(helpTextManager.get(fontSetting.type));
      }
    },

    clear() {
      monogram$.val('');
      this.storage = STYLE_CLASSES.fonts.reduce((storage, font) => {
        storage[font] = '';
        return storage;
      }, {})
    }
  };
  monogramManager.fontSettings = monogramManager.getFontSettings();

  // Emoji management
  const emojiManager = {
    selectedEmojis: new Set(),

    init() {
      this.buildEmojiGrid();
      this.bindEvents();
    },

    buildEmojiGrid() {
      const grid = $('.emoji-grid');
      grid.empty();

      CONFIG.emojis.list.forEach(emoji => {
        const button = $(`
          <button type="button" class="emoji-option"
                  data-emoji="${emoji.unicode}"
                  data-name="${emoji.name}"
                  title="${emoji.label}">
            ${emoji.unicode}
          </button>
        `);
        grid.append(button);
      });
    },

    // Fonts whose glyph set includes the Devos emojis.
    supportedFonts: ['sansserif', 'serif'],

    isSupportedFont() {
      return this.supportedFonts.includes(currentFont);
    },

    togglePicker(show) {
      const picker = $('#emoji-picker');
      // Never expand under a font that can't render the emojis.
      const expand = show && this.isSupportedFont();

      if (expand) {
        picker.show();
        this.updateDisabledState();
      } else {
        picker.hide();
      }

      // Keep the caret in sync with the picker state.
      $('#emoji-trigger')
        .toggleClass('open', expand)
        .attr('aria-expanded', expand ? 'true' : 'false')
        .attr('title', expand ? 'Ocultar emojis' : 'Mostrar emojis')
        .attr('aria-label', expand ? 'Ocultar emojis' : 'Mostrar emojis');
    },

    updateDisabledState() {
      $('.emoji-option').each((i, el) => {
        const $el = $(el);
        const emojiName = $el.data('name');
        $el.toggleClass('disabled', this.selectedEmojis.has(emojiName));
      });
    },

    insertEmoji(unicode, name) {
      if (this.selectedEmojis.has(name)) return;

      const input = monogram$[0];

      // Dot Charm accepts a single emoji: replace whatever is there instead of appending.
      if (isCharm) {
        this.selectedEmojis.clear();
        input.value = unicode;
        input.setSelectionRange(unicode.length, unicode.length);
        this.selectedEmojis.add(name);
        this.updatePreview();
        this.togglePicker(false);
        return;
      }

      const start = input.selectionStart;
      const end = input.selectionEnd;
      const currentValue = input.value;

      // Insert emoji at cursor position
      const newValue = currentValue.substring(0, start) + unicode + currentValue.substring(end);
      input.value = newValue;

      // Update cursor position
      const newPos = start + unicode.length;
      input.setSelectionRange(newPos, newPos);

      // Track selected emoji
      this.selectedEmojis.add(name);

      // Update the preview but leave the picker open — the monogram accepts several
      // emojis, and the field keeps focus so the caret / an outside click still closes it.
      this.updatePreview();
      input.focus();
      input.setSelectionRange(newPos, newPos);
    },

    updatePreview() {
      // Trigger the existing input event to update engrave preview
      monogram$.trigger('input');
      this.updateDisabledState();
      this.updateEmojiNamesField();
    },

    updateEmojiNamesField() {
      // Get all emoji names from the current monogram text
      const monogramText = monogram$.val();
      const emojiNames = [];

      CONFIG.emojis.list.forEach(emoji => {
        if (monogramText.includes(emoji.unicode)) {
          emojiNames.push(emoji.label);
        }
      });

      // Update the hidden field with comma-separated emoji names
      $('#emoji-names').val(emojiNames.join(', '));
    },

    reset() {
      this.selectedEmojis.clear();
      this.updateDisabledState();
    },

    // Extract emojis from text to track what's currently used
    analyzeText(text) {
      this.selectedEmojis.clear();
      CONFIG.emojis.list.forEach(emoji => {
        if (text.includes(emoji.unicode)) {
          this.selectedEmojis.add(emoji.name);
        }
      });
      // The picker is visible while the user types, so refresh the greyed-out state.
      this.updateDisabledState();
      // Keep the plain-text emoji names (sent to the cart/email) in sync with the
      // monogram text, not only with picker clicks: typing, deleting and font
      // switches all go through here.
      this.updateEmojiNamesField();
    },

    bindEvents() {
      // Emoji trigger button click
      $(document).on('click', '#emoji-trigger', (e) => {
        e.preventDefault();
        const isVisible = $('#emoji-picker').is(':visible');
        this.togglePicker(!isVisible);
      });

      // Emoji selection
      $(document).on('click', '.emoji-option:not(.disabled)', (e) => {
        const $target = $(e.target);
        const unicode = $target.data('emoji');
        const name = $target.data('name');
        this.insertEmoji(unicode, name);
      });

      // Open the picker automatically when the monogram field is selected, so users
      // don't have to discover the caret. togglePicker() ignores this under fonts
      // that can't render the emojis.
      monogram$.on('focus click', () => this.togglePicker(true));

      // Close the picker when clicking outside. The monogram field is part of the
      // picker interaction, so clicking it should not close the menu — the caret and
      // clicking outside the field are the two ways to collapse it.
      $(document).on('click', (e) => {
        if (!$(e.target).closest('#emoji-trigger, #emoji-picker, #monogram').length) {
          this.togglePicker(false);
        }
      });
    }
  };

  // Charm upcharges. Independent of extraChargeManager so a charm add-on and a paid
  // font (shadow/classic/sketch) can both be billed on the same line item.
  const charmChargeManager = {
    desired: 1,

    getCheckbox(value) {
      return $(`input:checkbox[value=${value}]`);
    },

    // Re-apply the last requested count once the app has rendered its checkboxes.
    sync() {
      this.apply(this.desired, true);
    },

    // Check the charge matching `count`, uncheck every other charm charge.
    apply(count, quiet = false) {
      this.desired = count;
      Object.entries(CONFIG.charms.charges).forEach(([chargeCount, charge]) => {
        const checkbox = this.getCheckbox(charge.checkbox);
        const shouldBeChecked = Number(chargeCount) === count;

        if (!checkbox.length) {
          // The Custom Product Options app injects these into .w3-product-options.
          // A missing one means the app isn't configured for this product, and the
          // extra charms would ship free — so make it loud rather than silent.
          if (shouldBeChecked && !quiet) {
            console.error(
              `[atelier] Charm upcharge checkbox "${charge.checkbox}" (${charge.price}) is not in ` +
              `the DOM. The Custom Product Options app is not configured for this product, so ` +
              `${count} charms will be charged as one.`
            );
          }
          return;
        }

        if (shouldBeChecked !== checkbox.is(':checked')) {
          checkbox.trigger('click');
        }
      });
    }
  };

  // Keeps the app's injected checkboxes in step with what the customer picked.
  // Runs when the Custom Product Options widget (re)renders and right before the
  // product form submits, so a font picked before the app loaded is still billed.
  const appOptionsSync = {
    syncAll() {
      extraChargeManager.sync();
      if ($('.make-it-personal.charms').length) {
        charmChargeManager.sync();
      }
    },

    init() {
      const container = document.querySelector('.w3-product-options');
      if (container) {
        let pending = null;
        new MutationObserver(() => {
          clearTimeout(pending);
          pending = setTimeout(() => this.syncAll(), 50);
        }).observe(container, {childList: true, subtree: true});
      }

      // Capture-phase listeners run before the app's own submit/click handlers.
      const form = document.querySelector('form[action^="/cart/add"]');
      if (form) {
        form.addEventListener('submit', () => this.syncAll(), true);
        form.querySelectorAll('[type=submit]').forEach(button => {
          button.addEventListener('click', () => this.syncAll(), true);
        });
      }
    }
  };

  // Charm picker: pick how many charms (1 included, up to 3) and which ones.
  const charmManager = {
    // Handles in the order they were picked — the newest is the one replaced when
    // the user clicks a new charm while every slot is taken.
    selected: [],
    count: 1,

    init() {
      this.container$ = $('.make-it-personal.charms');
      // The Liquid conditional is the single source of truth for which products
      // get charms, so absence of the block is the only check we need.
      if (!this.container$.length) return;

      this.grid$ = this.container$.find('.charm-grid');
      this.countRadios$ = this.container$.find('input[name="charm-count"]');
      this.priceLabel$ = this.container$.find('.charm-count-price');
      this.counter$ = this.container$.find('.charm-selected-counter');
      this.error$ = this.container$.find('.charm-error');
      this.namesField$ = $('#charm-names');
      this.countField$ = $('#charm-count');

      this.buildGrid();
      this.bindEvents();
      this.setCount(1);
    },

    buildGrid() {
      this.grid$.empty();

      CONFIG.charms.list.forEach(charm => {
        this.grid$.append(`
          <button type="button" class="charm-option"
                  data-handle="${charm.handle}"
                  aria-pressed="false"
                  title="${charm.label}">
            <img src="${window.charmImageUrls[charm.handle]}" alt="${charm.label}" loading="lazy">
            <span class="charm-remove" aria-hidden="true">&times;</span>
          </button>
        `);
      });
    },

    setCount(count) {
      this.count = count;

      // Dropping the count discards the most recently picked charms first, which is
      // the same rule replacement uses.
      while (this.selected.length > this.count) {
        this.selected.pop();
      }

      const charge = CONFIG.charms.charges[count];
      this.priceLabel$.text(charge ? `+ ${charge.price}` : '(incluido)');
      charmChargeManager.apply(count);

      this.render();
    },

    toggle(handle) {
      const index = this.selected.indexOf(handle);

      if (index !== -1) {
        this.selected.splice(index, 1);
      } else if (this.selected.length < this.count) {
        this.selected.push(handle);
      } else {
        // Every slot is taken: replace the newest pick so a click is never a no-op.
        this.selected.pop();
        this.selected.push(handle);
      }

      this.render();
    },

    render() {
      this.grid$.find('.charm-option').each((i, el) => {
        const $el = $(el);
        const isSelected = this.selected.includes($el.data('handle'));
        $el.toggleClass('selected', isSelected).attr('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.counter$.text(`Seleccionados: ${this.selected.length} de ${this.count}`);
      this.container$.toggleClass('charms-complete', this.selected.length === this.count);

      if (this.selected.length === this.count) {
        this.error$.hide();
      }

      this.syncFields();
    },

    syncFields() {
      // Keep cart order stable and readable rather than click-ordered.
      const labels = CONFIG.charms.list
        .filter(charm => this.selected.includes(charm.handle))
        .map(charm => charm.label);

      this.namesField$.val(labels.join(', '));
      this.countField$.val(String(this.count));
    },

    isComplete() {
      return !this.container$ || !this.container$.length || this.selected.length === this.count;
    },

    showError() {
      const missing = this.count - this.selected.length;
      this.error$
        .text(`Selecciona ${missing} charm${missing === 1 ? '' : 's'} más para completar tu pedido.`)
        .show();
    },

    bindEvents() {
      this.countRadios$.on('change', (e) => this.setCount(Number(e.target.value)));

      this.grid$.on('click', '.charm-option', (e) => {
        this.toggle($(e.currentTarget).data('handle'));
      });

      // Block add-to-cart until the picked charms match the selected count.
      this.container$.closest('form').on('submit', (e) => {
        if (!this.isComplete()) {
          this.showError();
          this.container$[0].scrollIntoView({behavior: 'smooth', block: 'center'});
          e.preventDefault();
          return false;
        }
      });
    }
  };

  const positionManager = {
    elements: positionElements,

    print_fonts: Object.entries(CONFIG.styles.fonts)
      .filter(([key, value]) => value.type === CONFIG.styles.fontType.PRINT)
      .map(([key]) => key),

    show() {
      const position = productProps[product]?.position;
      if (!position || !this.print_fonts.includes(currentFont)) {
        this.hide();
        return;
      }

      const positionDetail = CONFIG.styles.positions[position];
      if (!positionDetail) return;

      // Hide all position options first
      monogramPositionOptions$.parent().hide();
      monogramPositionOptions$.removeAttr('checked');

      // Show relevant options
      positionDetail.options.forEach(option => {
        this.elements[option].parent().show();
      });

      // Set default option
      this.elements[positionDetail.default].prop('checked', true);
      selectedPosition$.text(stringUtils.toProperCase(positionDetail.defaultText));
      engrave$.removeClass(positions.join(' '));
      engrave$.addClass(positionDetail.default);
      monogramPosition$.show();
    },

    hide() {
      monogramPositionOptions$.parent().hide();
      monogramPositionOptions$.prop('checked', false);
      monogramPosition$.hide();
      selectedPosition$.text('');
      engrave$.removeClass(positions.join(' '));
    },

    // Helper method to check if position options should be shown
    shouldShow(font) {
      return this.print_fonts.includes(font) && productProps[product]?.position;
    },

    updatePosition(value) {
      if (!value) return;

      // Normalize value to lowercase for class names
      const positionClass = value.toLowerCase();

      // Remove selection from all options
      monogramPositionOptions$.prop('checked', false);

      // Select the appropriate option
      this.elements[positionClass].prop('checked', true);

      // Update position text display
      selectedPosition$.text(` ${stringUtils.toProperCase(value)}`);

      // Update engrave classes
      engrave$
        .removeClass(positions.join(' '))
        .addClass(positionClass);
    }
  };

  const fontManager = {
    update(font) {
      const config = CONFIG.styles.fonts[font];
      if (!config) return;

      // Update font display
      const displayFont = config.hasExtraCharge
        ? `${font} <strong>+ ${CONFIG.pricing.extraCharge}</strong>`
        : font;

      // Update leather selection
      const currentLeather$ = $(`img[src*="${currentLeather}"]`);
      currentLeather$.trigger('click');

      // Update UI elements
      if (font === 'smile') {
        selectedFont$.html(`Operación Sonrisa <strong>+ ${config.priceLabel}</strong>`);
      } else {
        selectedFont$.html(displayFont === 'sansserif' ? 'Sans-serif' : stringUtils.toProperCase(displayFont));
      }
      engrave$.html('').removeClass(CONFIG.styles.classes.fonts.join(' '));
      monogram$.prop('disabled', false);

      // Update font settings
      this.setFont(font);
      currentFont = font;

      // Update visual states
      fontSelection$.removeClass('selected');
      $(`.font-selection.${font}`).addClass('selected');

      // Reset existing settings
      positionManager.hide();
      extraChargeManager.removeAll();

      // Apply font-specific settings
      if (config.type === FONT_TYPES.PRINT) {
        this.setPrintFont(font, config);
      } else if (config.type === FONT_TYPES.STAMP) {
        this.setSmileFont(font);
      } else {
        this.setEngravedFont(font);
      }

      // Show/hide emoji caret for sans-serif and serif fonts
      const emojiTrigger = $('#emoji-trigger');
      if (emojiManager.isSupportedFont()) {
        emojiTrigger.show();
        emojiManager.analyzeText(monogram$.val());
      } else {
        emojiTrigger.hide();
        emojiManager.togglePicker(false);
        // Clear emoji names field when switching away from emoji-supporting fonts
        $('#emoji-names').val('');
      }
    },

    setPrintFont(font, config) {
      // Hide foil colors for print fonts
      foilColors$.hide();

      // Show position options for print fonts
      positionManager.show();

      // Get current selected colors from UI
      const currentTextColor = shadowText.selectedTextColor$.text().trim();
      const currentShadowColor = shadowText.selectedShadowColor$.text().trim();

      // Set form values using selected colors or defaults if not set
      if (currentTextColor) {
        formElements.foil$.val(currentTextColor);
      } else {
        formElements.foil$.val(config.defaultColor);
        shadowText.selectedTextColor$.text(config.defaultColor);
      }

      // Handle shadow colors if applicable
      if (config.hasShadowColors) {
        if (currentShadowColor) {
          formElements.shadow$.val(currentShadowColor);
        } else {
          formElements.shadow$.val(config.defaultShadow);
          shadowText.selectedShadowColor$.text(config.defaultShadow);
        }
        if (!product.endsWith("- Bows") && !product.endsWith("- Stripes") && !product.endsWith("- Waves") && !product.endsWith("- Dots")) {
          shadowText.shadowColors$.show();
        }
      } else {
        formElements.shadow$.val('');
        shadowText.shadowColors$.hide();
      }

      // Show font colors
      if (!product.endsWith("- Bows") && !product.endsWith("- Stripes") && !product.endsWith("- Waves") && !product.endsWith("- Dots")) {
        shadowText.fontColors$.show();
      }

      // Update engrave classes
      engrave$
        .removeClass(CONFIG.styles.classes.textColors.join(' '))
        .removeClass(CONFIG.styles.classes.shadowColors.join(' '))
        .removeClass(CONFIG.styles.classes.foilColors.join(' '))
        .removeClass(CONFIG.styles.classes.fonts.join(' '))
        .addClass(font)
        .addClass(`${shadowText.selectedTextColor$.text().trim().toLowerCase() || 'midnight'}-t`);

      if (config.hasShadowColors) {
        engrave$.addClass(`${shadowText.selectedShadowColor$.text().trim().toLowerCase()}-s`);
      }

      // Waves/Dots include the shadow print in their price. Init auto-selects
      // shadow for them, and appOptionsSync would bill it once the app loads.
      if (product.endsWith('- Waves') || product.endsWith('- Dots')) return;

      // Add extra charge
      extraChargeManager.add(font.toLowerCase());
    },

    setEngravedFont(font, config) {
      // Show foil colors for engraved fonts
      foilColors$.show();

      // Hide color options
      shadowText.fontColors$.hide();
      shadowText.shadowColors$.hide();

      // Clear shadow value
      formElements.shadow$.val('');

      // Set color from UI to the hidden form field
      const currentSelectedFoil = selectedFoil$.text().trim();
      formElements.foil$.val(currentSelectedFoil);

      // Update engrave classes
      engrave$
        .removeClass(CONFIG.styles.classes.textColors.join(' '))
        .removeClass(CONFIG.styles.classes.shadowColors.join(' '))
        .removeClass(CONFIG.styles.classes.foilColors.join(' '))
        .removeClass(CONFIG.styles.classes.fonts.join(' '))
        .addClass(font)
        .addClass(currentSelectedFoil.toLowerCase());
    },

    // Operación Sonrisa: happy-face stamp engraved in a foil color, plus a $5 donation.
    // Behaves like an engraved font (foil colors, no shadow/position options) with an extra charge.
    setSmileFont(font) {
      foilColors$.show();
      shadowText.fontColors$.hide();
      shadowText.shadowColors$.hide();
      formElements.shadow$.val('');

      const currentSelectedFoil = selectedFoil$.text().trim();
      formElements.foil$.val(currentSelectedFoil);

      // Update engrave classes (the face glyph is rendered via the .engrave.smile:before CSS rule)
      engrave$
        .removeClass(CONFIG.styles.classes.textColors.join(' '))
        .removeClass(CONFIG.styles.classes.shadowColors.join(' '))
        .removeClass(CONFIG.styles.classes.foilColors.join(' '))
        .removeClass(CONFIG.styles.classes.fonts.join(' '))
        .addClass(font)
        .addClass(currentSelectedFoil.toLowerCase());

      // Add the Operación Sonrisa donation via the Custom Product Options app checkbox
      extraChargeManager.add('smile');
    },

    setFont(font) {
      formElements.font$.val(font === 'smile' ? 'Operación Sonrisa' : font);
    },

    updateFoil(foil) {
      selectedFoil$.text(stringUtils.toProperCase(foil));
      formElements.foil$.val(foil);
      foilSelection$.removeClass('selected');
      engrave$
        .removeClass(CONFIG.styles.classes.foilColors.join(' '))
        .addClass(foil.toLowerCase());
      $(`.foil-selection.${foil.toLowerCase()}`).addClass('selected');
    },

    updateFontColor(fontColor) {
      shadowText.selectedTextColor$.text(stringUtils.toProperCase(fontColor));
      formElements.foil$.val(fontColor);
      shadowText.fontColorsSelection$.removeClass('selected');
      engrave$
        .removeClass(CONFIG.styles.classes.textColors.join(' '))
        .addClass(`${fontColor.toLowerCase().trim()}-t`);
      $(`.shadow-text-font-color-selection.${fontColor}`).addClass('selected');
    },

    updateShadowColor(shadowColor) {
      shadowText.selectedShadowColor$.text(stringUtils.toProperCase(shadowColor));
      formElements.shadow$.val(shadowColor);
      shadowText.shadowColorsSelection$.removeClass('selected');

      engrave$
        .removeClass(CONFIG.styles.classes.shadowColors.join(' '))
        .addClass(`${shadowColor.toLowerCase().trim()}-s`);
      $(`.shadow-text-shadow-color-selection.${shadowColor.toLowerCase()}`).addClass('selected');
    }
  };

  const leatherManager = {
    patterns: {
      hardware: {
        gold: ', herrería en gold',
        silver: ', herrería en silver'
      },
      colorMappings: {
        'emerald': 'hunter_green',
        'navy': 'ink'
      }
    },

    setColorForCiego() {
      const leatherColor = this.normalizeColor($('span.color-name').text());

      // Normalize all leather colors in the array the same way
      const normalizedLeatherColors = CONFIG.styles.classes.leatherColors.map(color =>
        this.normalizeColor(color)
      );

      // Remove all normalized leather color classes first
      defaultFoil$.removeClass(normalizedLeatherColors.join(' '));

      // Add the new leather color
      defaultFoil$.addClass(leatherColor);
    },

    getLeatherColor(leatherColor) {
      currentLeather = `${leatherColor}.jpg`;
      const altText = $('.slick-current.slick-active img').attr('alt') ||
                     leatherColor.replaceAll('_', ' ');
      return this.normalizeColor(altText);
    },

    setLeatherColor(leatherColor) {
      engrave$
        .removeClass(CONFIG.styles.classes.leatherColors.join(' '))
        .addClass(this.normalizeColor(leatherColor));
    },

    normalizeColor(color) {
      return color
        .toLowerCase()
        // First remove known modifiers
        .replace(/\s*main\b/i, '')
        // Replace _mag suffix (with underscore)
        .replace(/_mag\b/i, '')
        // Also handle space + mag pattern
        .replace(/\s+mag\b/i, '')
        .replace(/\s*vegan\b/i, '')
        // Then handle hardware patterns
        .replace(this.patterns.hardware.gold, '')
        .replace(this.patterns.hardware.silver, '')
        .replace('_gold', '')
        .replace('_silver', '')
        // Remove any remaining commas and trim
        .replace(/,/g, '')
        .trim()
        // Replace remaining spaces with underscores
        .replace(/\s+/g, '_')
        // Remove any trailing underscores that might have been left
        .replace(/_+$/g, '')
        // Apply color mappings
        .replace('emerald', this.patterns.colorMappings.emerald)
        .replace('navy', this.patterns.colorMappings.navy);
    }
  };

  const inputManager = {
    restrictKeyInput(e, keyCode, char) {
      const font = formElements.font$.val();
      let isAllowed = true;
      prevMonogram = monogram$.val();

      // Dot Charm: emoji-only field. The emoji is set from the picker, so block any typed
      // character and allow only navigation keys (backspace/delete/arrows) to clear it.
      if (isCharm) {
        if (!CONFIG.personalization.allowedChars.keys.navigation.includes(keyCode)) {
          e.preventDefault();
        }
        return;
      }

      if (font === 'sansserif') {
        isAllowed = !char ?
          CONFIG.personalization.allowedChars.keys.sansserif.includes(keyCode) :
          CONFIG.personalization.allowedChars.keys.navigation.includes(keyCode) || CONFIG.personalization.allowedChars.chars.sansserif.includes(char);
      } else if (font === 'serif') {
        isAllowed = !char ?
          CONFIG.personalization.allowedChars.keys.serif.includes(keyCode) :
          CONFIG.personalization.allowedChars.keys.navigation.includes(keyCode) || CONFIG.personalization.allowedChars.chars.serif.includes(char);
      }

      if (!isAllowed) {
        e.preventDefault();
      }
    },

    clearHiddenInputs() {
      Object.values(formElements).forEach(element => element.val(''));
      extraChargeManager.removeAll();
    },

    removeRequired() {
      const requiredElements = [
        monogram$,
        formElements.font$,
        formElements.foil$,
        formElements.shadow$,
        monogramPositionOptions$
      ];

      requiredElements.forEach(element => element.removeAttr('required'));
    }
  };

  const fontVisibilityManager = {
    defaultFont$: null,

    elements: {
      iridiscente: fontElements.iridiscente,
      sansserif: fontElements.sansserif,
      serif: fontElements.serif,
      shadow: fontElements.shadow,
      classic: fontElements.classic,
      sketch: fontElements.sketch,
      smile: fontElements.smile
    },

    show(fontType) {
      this.elements[fontType].parent().show();
    },

    hide(fontType) {
      this.elements[fontType].parent().hide();
    },

    initializeFonts(product) {
      if (!product) return;

      const delays = {
        serif: 500,
        shadow: 500,
        classic: 500,
        sketch: 500,
        smile: 500
      };

      Object.entries(delays).forEach(([font, delay]) => {
        const maxLength = CONFIG.personalization.limits[font];
        if (maxLength) {
          setTimeout(() => this.show(font), delay);
        }
      });
      // Determine the topFont (first non-zero limit)
      const topFont = Object.keys(CONFIG.personalization.limits)
        .find(font => CONFIG.personalization.limits[font] > 0);

      if (topFont) {
        this.defaultFont$ = this.elements[topFont];
        this.defaultFont$.click();
      }
    }
  };

  const eventManager = {
    init() {
      this.setupPersonalizationHandlers();
      this.setupPositionHandlers();
      this.setupColorHandlers();
      this.setupNavigationHandlers();
      this.setupInputHandlers();
      this.setupPackagingHandlers();
    },

    setupPersonalizationHandlers() {
      $('input[type="radio"][name="properties[Personalizar]"]').change(function(e) {
        const value = $(this).val();
        if (value === 'No') {
          personalizationManager.hide();
          inputManager.removeRequired();
          monogramManager.clear();
          engraveManager.clear();
          inputManager.clearHiddenInputs();
          engraveManager.hide();
          positionManager.hide();
        } else if (value === 'Si') {
          personalizationManager.reset();
          fontManager.update(fontVisibilityManager.defaultFont$);
          fontVisibilityManager.initializeFonts(product);
          monogramManager.set('sanserif');
          engraveManager.reset();
          formElements.foil$.val('Ciego');
          personalizationManager.show();
        }
      });
    },

    setupPositionHandlers() {
      $('input[type="radio"][name="properties[Posicion]"]').change(function(e) {
        positionManager.updatePosition($(this).val());
      });
    },

    setupColorHandlers() {
      $('.color_swatches img').click(() => {
        setTimeout(() => leatherManager.setColorForCiego(), 500);
      });

      // Click handler for font selection
      fontSelection$.click(function(e) {
        const font = e.currentTarget.name;
        monogramManager.save(currentFont);
        currentFont = font;
        fontManager.update(font);
        monogramManager.set(font);
        engraveManager.setText(font);
      });

      // Click handler for foil selection
      foilSelection$.click(function(e) {
        fontManager.updateFoil(e.currentTarget.name);
      });

      // Click handlers for shadow text colors
      shadowText.fontColorsSelection$.click(function(e) {
        fontManager.updateFontColor(e.currentTarget.name);
      });

      shadowText.shadowColorsSelection$.click(function(e) {
        fontManager.updateShadowColor(e.currentTarget.name);
      });
    },

    setupNavigationHandlers() {
      const isWavesOrDots = product.endsWith('- Waves') || product.endsWith('- Dots');

      // Click handler for swatches
      swatches$.on('click touchend', function() {
        leatherManager.setLeatherColor(leatherManager.getLeatherColor($(this).val()));

        // Auto-update ink colors for Waves/Dots products
        if (isWavesOrDots) {
          const designType = product.endsWith('- Waves') ? 'waves' : 'dots';
          const normalizedLeather = leatherManager.normalizeColor($(this).val());
          const inkMap = WAVES_DOTS_INK_MAP[designType];
          const colors = inkMap[normalizedLeather] || Object.values(inkMap)[0];

          engrave$.css('color', colors.text);
          engrave$.css('text-shadow',
            `-1px 1px 0px ${colors.shadow}, -2px 2px 0px ${colors.shadow}, -3px 3px 0px ${colors.shadow}`
          );
          formElements.foil$.val(colors.text);
          formElements.shadow$.val(colors.shadow);
        }
      });

      const handleSlickChange = () => {
        setTimeout(() => {
          const altText = $('.slick-current.slick-active img').attr('alt');
          // 'swiped' fires for any swipe on the page, and some slides have no
          // alt text — nothing to read a leather color from (ATELIER-THEME-N).
          if (!altText) return;
          const numOfWords = altText.split(' ').length;
          const leatherColor = altText.split(' ')
            .slice(0, numOfWords - 1)
            .join('_')
            .toLowerCase();
          leatherManager.setLeatherColor(leatherManager.getLeatherColor(leatherColor));
          monogramManager.save(currentFont)
          engraveManager.toggleVisibility(altText);

          // Auto-update ink colors for Waves/Dots when navigating via slick arrows
          if (isWavesOrDots) {
            const designType = product.endsWith('- Waves') ? 'waves' : 'dots';
            const normalizedLeather = leatherManager.normalizeColor(leatherColor);
            const inkMap = WAVES_DOTS_INK_MAP[designType];
            const colors = inkMap[normalizedLeather] || Object.values(inkMap)[0];

            engrave$.css('color', colors.text);
            engrave$.css('text-shadow',
              `-1px 1px 0px ${colors.shadow}, -2px 2px 0px ${colors.shadow}, -3px 3px 0px ${colors.shadow}`
            );
            formElements.foil$.val(colors.text);
            formElements.shadow$.val(colors.shadow);
          }
        }, 200);
      };

      // Navigation handlers
      slickArrows$.click(handleSlickChange);
      slickDots$.click(handleSlickChange);
      document.addEventListener('swiped', handleSlickChange);
      thumbs$.click(function() {
        monogramManager.save(currentFont)
        engraveManager.toggleVisibility($(this).attr('alt'));
      });
    },

    setupInputHandlers() {
      // Handle text input (handles paste and input method events)
      monogram$.on('textInput', function(e) {
        if (!e.key && e.originalEvent.data.charCodeAt(0)) {
          inputManager.restrictKeyInput(e, e.originalEvent.data.charCodeAt(0), e.key);
        }
        engrave$.text(monogram$.val());
      });

      // Handle keyboard input
      monogram$.keydown(function(e) {
        if (!e.originalEvent.data && e.key !== 'Unidentified') {
          inputManager.restrictKeyInput(e, e.keyCode, e.key);
        }
      });

      // Waves/Dots are engraved in uppercase only (as in the product shots),
      // so uppercase the value itself: the preview and the cart get the same text.
      const isWavesOrDots = product.endsWith('- Waves') || product.endsWith('- Dots');
      const toUpperCaseValue = input => {
        const upper = input.value.toUpperCase();
        if (upper !== input.value) {
          const { selectionStart, selectionEnd } = input;
          input.value = upper;
          input.setSelectionRange(selectionStart, selectionEnd);
        }
      };

      if (isWavesOrDots) {
        // Mobile keyboards then type capitals, so the value rarely needs rewriting
        monogram$.attr('autocapitalize', 'characters');
        // Rewriting mid-composition garbles text on some Android keyboards:
        // uppercase once the composed text is committed instead
        monogram$.on('compositionend', function() {
          toUpperCaseValue(this);
          engrave$.text(this.value);
        });
      }

      // Handle all input changes (covers any case we might have missed)
      monogram$.on('input', function(e) {
        if (isWavesOrDots && !e.originalEvent?.isComposing) {
          toUpperCaseValue(this);
        }
        engrave$.text($(this).val());
        if (emojiManager.isSupportedFont()) {
          emojiManager.analyzeText($(this).val());
        }
      });

      // Handle blur for emoji analysis
      monogram$.blur(function() {
        if (emojiManager.isSupportedFont()) {
          emojiManager.analyzeText($(this).val());
        }
      });
    },

    setupPackagingHandlers() {
      const packing$ = $('.btn.pack-selection');
      const packingInput$ = $('#packing');

      packing$.click(function(e) {
        const $this = $(this);
        packing$.removeClass('selected');
        $this.addClass('selected');

        // Update hidden input value
        const packingType = $this.hasClass('dome') ? 'Dome' : 'Gift Bag';
        packingInput$.val(packingType);

        // Here we'll add any price adjustment logic later
        // For now, just set up the structure
        if ($this.hasClass('dome')) {
          extraChargeManager.add('dome');
          selectedFont$.html(`Dome Iridiscente <strong>+ ${CONFIG.pricing.extraCharge}</strong>`)
        } else {
          selectedFont$.html('Iridiscente');
        }
      });

      // Set default selection
      packing$.filter('.giftbag').addClass('selected');
      packingInput$.val('Gift Bag');
    }
  };

  const delayedDeliveryManager = {
    modal: $('#delayed-delivery-modal'),
    confirmationInput: $('#delayed-deboss-confirmation-message'),
    confirmationState: $('#delayed-delivery-confirmed'),
    alternativeMessage: $('#alternative-options-message'),
    finalMessage: $('#final-options-message'),
    cancelBtn: $('#cancel-delayed-delivery'),
    confirmBtn: $('#confirm-delayed-delivery'),
    confirmMessage: 'Entrega a partir de Enero 10, 2025',
    hasAlternatives: false,

    init() {
      this.setupEventListeners();
      this.checkInitialFont();
    },

    checkInitialFont() {
      if (['sansserif', 'serif', 'shadow', 'classic', 'sketch', 'iridiscente'].includes(currentFont)) {
        this.hasAlternatives = false;
        this.alternativeMessage.toggleClass('hidden', !this.hasAlternatives);
        this.cancelBtn.text(this.hasAlternatives ? 'Gracias, elegiré PRINT' : 'Gracias, elegiré sin personalización');
        this.showModal();
      }
    },

    setupEventListeners() {
      this.confirmBtn.click(() => this.handleConfirm());
      this.cancelBtn.click(() => this.handleCancel());

      // Modify existing font selection click handler
      fontSelection$.off('click').on('click', function(e) {
        const font = e.currentTarget.name;
        const isDebossFont = font === 'sansserif' || font === 'serif';
        const isPrintFont = font === 'shadow' || font === 'classic' || font === 'sketch' || font === 'iridiscente';

        if ((isDebossFont || isPrintFont) && delayedDeliveryManager.confirmationState.val() === '') {
          delayedDeliveryManager.showModal();
          return;
        }

        if ((isDebossFont || isPrintFont) && delayedDeliveryManager.confirmationState.val() === 'false') {
          return;
        }

        // Original font selection logic
        monogramManager.save(currentFont);
        currentFont = font;
        fontManager.update(font);
        monogramManager.set(font);
        engraveManager.setText(font);

        // Update confirmation message
        delayedDeliveryManager.updateConfirmationMessage(font);
      });
    },

    showModal() {
      const dialog = document.getElementById('delayed-delivery-modal');
      dialog.showModal();
    },

    hideModal() {
      const dialog = document.getElementById('delayed-delivery-modal');
      dialog.close();
    },

    handleConfirm() {
      this.confirmationState.val('true');
      this.updateConfirmationMessage(currentFont);
      this.hideModal();

      // Trigger font selection again
      $(`.font-selection.${currentFont}`).trigger('click');
    },


    handleCancel() {
      this.confirmationState.val('false');
      this.confirmationInput.val('');
      this.hideModal();

      // Disable deboss options
      fontElements.sansserif.prop('disabled', true).addClass('opacity-50');
      fontElements.serif.prop('disabled', true).addClass('opacity-50');
      fontElements.shadow.prop('disabled', true).addClass('opacity-50');
      fontElements.classic.prop('disabled', true).addClass('opacity-50');
      fontElements.sketch.prop('disabled', true).addClass('opacity-50');

      // Select first available non-deboss font
      if (this.hasAlternatives) {
        const alternativeFont = ['shadow', 'classic', 'sketch'].find(font =>
          CONFIG.personalization.limits[font] > 0
        );
        if (alternativeFont) {
          $(`.font-selection.${alternativeFont}`).trigger('click');
        }
      }

      $('.personalize-wrapper').hide();

      inputManager.removeRequired();
    },

    updateConfirmationMessage(font) {
      const isDebossFont = font === 'sansserif' || font === 'serif';
      const isPrintFont = font === 'shadow' || font === 'classic' || font === 'sketch' || font === 'iridiscente';
      this.confirmationInput.val((isDebossFont || isPrintFont) ? this.confirmMessage : '');
    }
  };

  const suggestionsManager = {
    // Initialize suggestions handling
    init() {
      // Add CSS to document head to hide products immediately
      this.addHidingStyles();

      // Handle products with no images
      this.hideNoImageProducts();
    },

    // Add CSS rules to hide auxiliary products immediately
    addHidingStyles() {
      const styles = CONFIG.products.hidden
        .map(id => `#ProductImageWrapper-${id}`)
        .join(', ');

      const styleTag = document.createElement('style');
      styleTag.textContent = `
        ${styles} {
          display: none !important;
        }
        ${styles} .grid__item.grid-product {
          display: none !important;
        }
        img[src*="no-image"].grid__item.grid-product {
          display: none !important;
        }
      `;

      document.head.appendChild(styleTag);
    },

    // Hide products with no images
    hideNoImageProducts() {
      $('img[src*="no-image"]')
        .parents('.grid__item.grid-product')
        .hide();
    }
  };

  const init = () => {
    const limits = CONFIG.personalization.limits;

    // Initialize all managers
    suggestionsManager.init();
    eventManager.init();
    emojiManager.init();
    charmManager.init();
    appOptionsSync.init();

    // Initial setup
    if (product) {
      console.log(product);
      leatherManager.setColorForCiego();
      monogramManager.set();

      // Set initial leather color and product type
      const leather = defaultSwatch$.val()?.toLowerCase() || 'sin-color';
      engrave$.addClass(leather);
      // Add-on products (Shadow, Classic, Extra Charm, ...) have no
      // productProps entry. Throwing here used to abort init before the
      // "hide personalization" step below ran (Sentry ATELIER-THEME-9).
      const productType = productProps[product]?.type;
      if (productType) engrave$.addClass(productType);
      if (product.includes('- Iridiscente')) {
        const font = 'iridiscente';
        const ink = 'midnight-t'
        engrave$.addClass(`${font} ${ink}`);
        monogramManager.save(font);
        currentFont = font;
        fontManager.update(font);
        monogramManager.set(font);
        engraveManager.setText(font);
      }

      // Waves/Dots initialization
      const isWavesOrDots = product.endsWith('- Waves') || product.endsWith('- Dots');
      if (isWavesOrDots) {
        const designType = product.endsWith('- Waves') ? 'waves' : 'dots';
        currentFont = 'shadow';

        // Extract device model class from product name
        // e.g. "iPhone 17 Pro Max - Waves" → "iphone_17_pro_max"
        // e.g. "Samsung S25+ - Dots" → "samsung_s25_plus"
        const modelClass = product
          .replace(/ - (Waves|Dots)$/, '')
          .toLowerCase()
          .replace(/\+/g, '_plus')
          .replace(/\s+/g, '_');

        // Set font hidden input to 'Waves' or 'Dots'
        formElements.font$.val(designType === 'waves' ? 'Waves' : 'Dots');

        // Get current leather and apply auto-colors
        const normalizedLeather = leatherManager.normalizeColor(
          defaultSwatch$.val()?.toLowerCase() || 'blush'
        );
        const inkMap = WAVES_DOTS_INK_MAP[designType];
        const colors = inkMap[normalizedLeather] || Object.values(inkMap)[0];

        // Apply engrave styling with inline colors
        engrave$.addClass(`shadow horizontal ${designType} ${modelClass}`);
        engrave$.css('color', colors.text);
        engrave$.css('text-shadow',
          `-1px 1px 0px ${colors.shadow}, -2px 2px 0px ${colors.shadow}, -3px 3px 0px ${colors.shadow}`
        );

        // Set max length to 2
        monogram$.attr('maxlength', 2);
        helpBlock$.html(`Máximo: 2 caracteres. ${HELP_TEXT_BASE}<br><br>`);

        // Hide sections that don't apply
        $(personalizationSelectors.font).hide();
        monogramPosition$.hide();
        foilColors$.hide();
        shadowText.fontColors$.hide();
        shadowText.shadowColors$.hide();

        // Set form values for cart
        formElements.foil$.val(colors.text);
        formElements.shadow$.val(colors.shadow);
      }

      // Initialize fonts based on product capabilities
      fontVisibilityManager.initializeFonts(product);
    }

    // Hide personalization if product doesn't support it
    // Skip for besties-duo and logo — they have their own custom form inside
    // personalize-wrapper (logo: the company-logo upload in product-template)
    const productType = productProps[product]?.type;
    const hasOwnForm = productType === 'besties-duo' || productType === 'logo';
    if (!Object.values(CONFIG.personalization.limits).some(limit => limit > 0) && !hasOwnForm) {
      // The markup defaults to Personalizar = Si with font/foil hidden inputs
      // pre-filled, so a non-personalizable product (e.g. tech) would still
      // submit "Personalizar: Si, Tipo de Letra, Color del Monograma" to the
      // cart. Select "No" and run its change handler, which clears those inputs
      // exactly as if the customer had picked No.
      $('#personalize-no').prop('checked', true).trigger('change');
      $('.personalize-wrapper').hide();
      inputManager.removeRequired();
    }
    // delayedDeliveryManager.init();
  };



  init();
});

$(document).ready(function() {
  // Skip execution if not in the product page
  try {
    if (typeof productData === 'undefined') {
      return;
    }
  } catch {
    return;
  }

  // Gift Manager
  const giftManager = {
    elements: {
      wrapper$: $('.gift-wrapper'),
      options$: $('.gift-wrap.card, .gift-wrap.from, .gift-wrap.for, .gift-wrap.message'),
      cards$: $('input[type="radio"][name="properties[Tarjeta]"]'),
      congrats$: $('input[type="radio"][value="Congrats"]'),
      from$: $('#from'),
      for$: $('#for'),
      message$: $('#mensaje')
    },

    nonGiftProducts: [
      'e-Gift Card',
      'e-Heart for VZLA',
      'Protector de Cámara',
      'Protector de Pantalla'
    ],

    init() {
      if (this.nonGiftProducts.includes(productData.title)) {
        this.elements.wrapper$.hide();
        return;
      }

      this.hideOptions();
      this.setupHandlers();
    },

    hideOptions() {
      this.elements.options$.hide();
      this.elements.cards$.removeAttr('checked');
    },

    setupHandlers() {
      $('input[type="radio"][name="properties[Para Regalo]"]').change((e) => {
        const isGift = $(e.target).val() === 'Si';
        this.toggleGiftOptions(isGift);
      });
    },

    toggleGiftOptions(show) {
      const elements = this.elements;
      const requiredFields = [
        elements.cards$,
        elements.from$,
        elements.for$,
        elements.message$
      ];

      if (show) {
        elements.options$.show();
        elements.congrats$.prop('checked', true);
        requiredFields.forEach(field => {
          field.prop('required', true).addClass('required');
        });
      } else {
        elements.options$.hide();
        elements.cards$.removeAttr('checked');
        requiredFields.forEach(field => {
          field.removeAttr('required').removeClass('required');
        });
      }
    }
  };

  // Tabs Manager
  const tabsManager = {
    elements: {
      tabs$: $('.tab'),
      contents$: $('.tab-content')
    },

    init() {
      this.setupHandlers();
    },

    setupHandlers() {
      this.elements.tabs$.click((e) => {
        const tab$ = $(e.currentTarget);
        const contentId = tab$.data('content-id');

        this.activateTab(tab$, contentId);
      });
    },

    activateTab(tab$, contentId) {
      const elements = this.elements;

      // Deactivate all tabs and contents
      elements.tabs$.removeClass('active');
      elements.contents$.removeClass('active');

      // Activate selected tab and its contents
      tab$.addClass('active');
      $(`#${contentId}, #${contentId}-m`).addClass('active');
    }
  };

  // Initialize managers
  giftManager.init();
  tabsManager.init();
});
// CUSTOM JS FOR ATELIER - Ends